import React from "react"
import PropTypes from "prop-types"
import Rule from "./Rule.js"
import FeatherIcon from 'feather-icons-react';
import 'moment-timezone';
import axios from "axios";


class Rules extends React.Component {
  state = {
    rules: this.props.rules.map((rule, i) => {
      var s_hours;
      var s_minutes;
      var s_seconds;
      var s_date;
      var s_comp;
      s_comp = rule.time_start_at.split(":");
      s_hours = s_comp[0];
      s_minutes = s_comp[1];
      s_seconds = s_comp[2];
      s_date = new Date();
      s_date.setUTCHours(s_hours);
      s_date.setUTCMinutes(s_minutes);
      s_date.setUTCSeconds(s_seconds);

      var e_hours;
      var e_minutes;
      var e_seconds;
      var e_date;
      var e_comp;
      e_comp = rule.time_end_at.split(":");
      e_hours = e_comp[0];
      e_minutes = e_comp[1];
      e_seconds = e_comp[2];
      e_date = new Date();
      e_date.setUTCHours(e_hours);
      e_date.setUTCMinutes(e_minutes);
      e_date.setUTCSeconds(0);
      e_date.setUTCSeconds(e_seconds);

      if (rule.default_rule) {
        rule.time_start_at = null
        rule.time_end_at = null
      } else {
        rule.time_start_at = s_date.toLocaleTimeString([], {hour12: false, hour: '2-digit', minute:'2-digit', second:'2-digit', timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone});
        rule.time_end_at = e_date.toLocaleTimeString([], {hour12: false, hour: '2-digit', minute:'2-digit', second:'2-digit', timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone});
      }
      return rule;
    }),
    editing: false,
    rule_undo: {}
  }

  onCreateRuleClick = (event) => {
    var rules = this.state.rules;
    var tmp_id = -Math.ceil(Math.random()* 1000000000000);
    var min_priority = 0;
    var new_rule = null;
    rules.map((rule, index) => {
      if (rule.priority > min_priority){
        min_priority = rule.priority;
      }
    });
    if (this.props.type == "Worker"){
      new_rule = Object.assign({},Object.assign(Rule.defaultProps.rule, {id: tmp_id, editing: true, priority: min_priority + 1}));
    } else {
      new_rule = Object.assign({},Object.assign(Rule.defaultProps.rule, {id: tmp_id, editing: true, priority: min_priority + 1, upscale_threshold: 100, upscale_ellapsed: 120, downscale_threshold: 50, downscale_ellapsed: 600, default_rule: false }));
    }
    
    rules = [new_rule].concat(rules);
    this.setState({rules: rules});
  }

  deleteRule = (rule) => {
    if (rule.remote_id) {
      const csrfToken = document.querySelector("meta[name=csrf-token]").content;
      const deleteRuleRequest = async () => {
        const response = await axios.delete(
          `${window.location.pathname}/${rule.remote_id}`,
          { headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken } }
        )
      }
      deleteRuleRequest();
    }
    var rules = this.state.rules;
    rules.map((rule_i, index) => {
      if (rule_i.id == rule.id){
        rules.splice(index, 1)
      }
    });
    this.setState({rules: rules});
  }

  onCreateRule = (old_rule_id, new_rule_id, updated_rule) => {
    var rules = this.state.rules;
    var updated_rules = rules.map((rule, index) => {
      if (rule.id == old_rule_id){
        rule = updated_rule;
        rule.id = new_rule_id;
      }
      return rule;
    });
    this.setState({rules: updated_rules});
  }

  saveRule = (rule) => {
    const csrfToken = document.querySelector("meta[name=csrf-token]").content;
    var response = null;
    const saveRuleRequest = async () => {
      if (rule.remote_id > 0) {
        response = await axios.put(
          `${window.location.pathname}/${rule.remote_id}`,
          { rule: rule, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
          { headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken } }
        )
       } else {
        response = await axios.post(
          `${window.location.pathname}`,
          { rule: rule, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
          { headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken } }
        )
      }
      var rules = this.state.rules.map((rule_i, index) => {
        if (rule_i.id == rule.id){
          rule.remote_id = response.data.id;
          return rule;
        }
        return rule_i;
      });

      this.setState({
        rules: rules,
      });
    }
    saveRuleRequest();
  }

  setRuleUndoMark = (rule_id) => {
    var r_undo = this.state.rule_undo
    var r_instance = null;
    

    this.state.rules.map((rule_i, index) => {
      if (rule_i.id == rule_id){
        r_instance = rule_i
        return r_instance;
      }
      return null;
    });

    r_undo[rule_id] = JSON.parse(JSON.stringify(r_instance));

    this.setState({
      rule_undo: r_undo
    });
  }

  rollbackToLastUndoMark = (rule_id) => {
    var rules = this.state.rules.map((rule_i, index) => {
      if (rule_i.id == rule_id){
        return this.state.rule_undo[rule_id];
      } else {
        return  rule_i;
      }
    });
    this.setState({
      rules: rules
    });
  }

  updateRule = (rule_id, field, value) => {
    var rules = this.state.rules.map((rule, index) => {
      if (rule.id == rule_id){
        rule[field] = value;
        return rule;
      }
      return rule;
    });

    this.setState({
      rules: rules,
    });
  }

  reorderUp = (rule) => {
    var rules = this.state.rules;
    rules.map((rule_i, index) => {
      if (rule_i.id == rule.id){
        var other_rule = this.state.rules[index-1];
        var temp_priority = other_rule.priority;
        other_rule.priority = rule.priority;
        rule.priority = temp_priority;
        this.saveRule(rule);
        this.saveRule(other_rule);
      }
    });
    this.setState({
      rules: rules.sort((a, b) => (a.default_rule - b.default_rule)*10 - (a.priority - b.priority)),
    });
  }

  reorderDown = (rule) => {
    var rules = this.state.rules;
    rules.map((rule_i, index) => {
      if (rule_i.id == rule.id){
        var other_rule = this.state.rules[index+1];
        var temp_priority = other_rule.priority;
        other_rule.priority = rule.priority;
        rule.priority = temp_priority;
        this.saveRule(rule);
        this.saveRule(other_rule);
      }
    });
    this.setState({
      rules: rules.sort((a, b) => (a.default_rule - b.default_rule)*10 - (a.priority - b.priority)),
    });
  }

  activeRuleId = () => {
    var active_rule_id = -1;
    var current_date = new Date();
    var current_time = (current_date.getHours() * 60 * 60 + current_date.getMinutes() * 60) * 1000;
    var current_dow  = current_date.toLocaleDateString({}, { weekday: 'long' });
    var i = 0;
    while (active_rule_id < 0){
      var rule = this.state.rules[i];
      if (rule.default_rule){
        active_rule_id = rule.id;
        break;
      }
      
      var s_hours;
      var s_minutes;
      var s_seconds;
      var s_date;
      var s_midnight;
      var s_comp;
      s_comp = rule.time_start_at.split(":");
      s_hours = s_comp[0];
      s_minutes = s_comp[1];
      s_seconds = s_comp[2];
      s_date = new Date();
      s_date.setUTCHours(s_hours);
      s_date.setUTCMinutes(s_minutes);
      s_date.setUTCSeconds(s_seconds);
      s_midnight = new Date();
      s_midnight.setUTCHours(0);
      s_midnight.setUTCMinutes(0);
      s_midnight.setUTCSeconds(0);    

      var e_hours;
      var e_minutes;
      var e_seconds;
      var e_date;
      var e_midnight;
      var e_comp;
      e_comp = rule.time_end_at.split(":");
      e_hours = e_comp[0];
      e_minutes = e_comp[1];
      e_seconds = e_comp[2];
      e_date = new Date();
      e_date.setUTCHours(e_hours);
      e_date.setUTCMinutes(e_minutes);
      e_date.setUTCSeconds(e_seconds);
      e_midnight = new Date();
      e_midnight.setUTCHours(0);
      e_midnight.setUTCMinutes(0);
      e_midnight.setUTCSeconds(0);    
      var start_time = s_date.getTime() - s_midnight.getTime();
      var end_time   = e_date.getTime() - e_midnight.getTime();
      var dow = rule.dow;

      if (dow.toLowerCase() == "everyday" || current_dow == dow || (dow.toLowerCase() == "weekend" && ["saturday", "sunday"].includes(current_dow.toLowerCase())) || (dow.toLowerCase() == "weekday" && ["monday", "tuesday", "wednesday", "thursday", "friday"].includes(current_dow.toLowerCase()))){
        if ((start_time <= current_time && end_time >= current_time) || ((start_time > end_time) && end_time >= current_time) || ((start_time > end_time) && start_time <= current_time)){
          active_rule_id = rule.id;
          break;
        }
      }
      i=i+1;
    }
    return active_rule_id;
  }

  render () {
    return (
      <React.Fragment>
        <div className="card card-header-actions h-100">
          <div className="card-header">
            <div className="small-mobile-gutter container">
              <div className="row rule-control">
                <div className="col-lg-3 col-8 pt-2">
                {this.props.type} Auto Scale Rules
                </div>
                <div className="col-lg-9 col-4 action-control mt-1 mb-1">
                  <div className="mr-1">
                    <button className="btn btn-green btn-sm" onClick={this.onCreateRuleClick}><FeatherIcon icon="file-plus"/> Create Rule</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="small-mobile-gutter container">
              {this.state.rules.map((rule, i) => (
                 <Rule rule={rule} type={this.props.type} options={this.props.options} rollbackToLastUndoMark={this.rollbackToLastUndoMark} setRuleUndoMark={this.setRuleUndoMark} key={this.state.rules[i].id} activeRuleId={this.activeRuleId} updateRule={this.updateRule} saveRule={this.saveRule} onCreateRule={this.onCreateRule} deleteRule={this.deleteRule} reorderDown={this.reorderDown} reorderUp={this.reorderUp} index={i} rule_count={this.state.rules.length} prev_rule={i > 0 ? this.state.rules[i - 1] : null}/>
              ))}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Rules.propTypes = {
  rules: PropTypes.array,
  options: PropTypes.object,
  type: PropTypes.string
};
export default Rules
